import { render, staticRenderFns } from "./ModalRegraDeCalculoIncluirOperadora.vue?vue&type=template&id=6472c906&scoped=true"
import script from "./ModalRegraDeCalculoIncluirOperadora.vue?vue&type=script&lang=ts"
export * from "./ModalRegraDeCalculoIncluirOperadora.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegraDeCalculoIncluirOperadora.vue?vue&type=style&index=0&id=6472c906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472c906",
  null
  
)

export default component.exports